kombi.closeModal = function(modalId) {
    const modalElement = document.getElementById(modalId);
    const modalInstance = modalElement && bootstrap.Modal.getInstance(modalElement);
    if (modalInstance) modalInstance.hide();
}